export interface WorkflowResponseTypeActionDTO {
  typeResponse: number; // Sent as number in the DTO. Equivalents are in the enum ResponseType
  activityLastExecutionRecord: {
    activityId: string;
    activityTypeStaticUid: string;
    completedAt: string;
    id: string;
    startedAt: string;
    state: {
      bacEntreeId: number;
      executionModeOption: number;
      value: number;
      valueConstraint: number; // each number has its equivalent with ActivityBacValueConstraint it'll determine which constraint is applied
      valueConstraintServiceId: number;
      variable: {
        id: string;
        name: string;
        typeName: string;
      };
    };
    status: 'Pending' | 'Running' | 'Completed' | 'Canceled' | 'Faulted';
    workflowInstanceId: string;
  };
  reponseDataJson: string;
}

export enum ResponseType {
  // equals DestinataireTypeReponse Backend
  Default = 0,
  YesNo = 1,
  WorkflowVariableService = 2,
  WorkflowVariableUser = 3,
  WorkflowVariableStatus = 4,
  WorkflowCourrierData = 5,
}

export enum ActivityBacValueConstraint {
  None = 0,
  ParentRootLevel = 1,
  ParentFirstLevel = 2,
  ParentAnyLevel = 3,
  ChildFirstLevel = 4,
  ChildAnyLevel = 5,
}
